
import { Component } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import selectType from "./children/selectType.vue";
import {
  getRechargecardStatistics,
  getChargeCardPage,
  updateCardStatus
  // deleteCard
} from "@/api/api-non-name";
import { getOptionList, optionKey } from "@/api/api-dict";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
@Component({
  components: {
    selectType,
    piSelectOper,
    piSelectTableData
  }
})
export default class PiSnonRealNameCardManagement extends mixins(
  tableMaxHeight
) {
  private cardMsgAll: objAny = {
    cancelNum: 0,
    cardNum: 0,
    employNum: 0
  };

  private statusColor = {
    0: "#868686",
    1: "#71B604",
    2: "#F39F31",
    3: "#6880FF"
  };
  private formInline: objAny = {
    globalSearch: "",
    oprPkId: "",
    queryType: "",
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private loading = false;
  private total = 0;
  private queryTypeList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [];
  private searchShow = true;
  private allTableData: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("nonCard.accountPkId"),
      key: "accountPkId",
      minWidth: 135,
      slot: "accountPkId"
    },
    {
      title: i18n.t("nonCard.cardPhysicalNumber"),
      key: "cardPhysicalNumber",
      minWidth: 150
    },
    {
      title: i18n.t("nonCard.memberType"),
      key: "memberType",
      slot: "memberType",
      minWidth: 150
    },
    {
      title: i18n.t("nonCard.name"),
      key: "contactName",
      minWidth: 150
    },
    {
      title: i18n.t("nonCard.phoneNo"),
      key: "phoneNo",
      slot: "phoneNo",
      minWidth: 110
    },
    {
      title: i18n.t("nonCard.email"),
      key: "email",
      minWidth: 110
    },
    {
      title: i18n.t("nonCard.cardStatus"),
      key: "cardStatus",
      minWidth: 100,
      slot: "cardStatus"
    },
    {
      title: i18n.t("nonCard.validity"),
      key: "validity",
      slot: "validity",
      minWidth: 180
    },
    {
      title: i18n.t("nonCard.createTime"),
      key: "createTime",
      sortable: true,
      minWidth: 155
    },
    {
      title: i18n.t("operation"),
      slot: "action",
      width: 200
      // align: "center"
    }
  ];
  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public searchClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
    this.getStatistics();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getChargeCardPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = this.$common.forTableList(ret.data);
    }
    this.loading = false;
  }

  async getStatistics(): Promise<void> {
    const ret = await getRechargecardStatistics({
      oprPkId: this.formInline.oprPkId
    });
    if (ret.status === this.$config.apiStatus) {
      if (ret.data.length > 0) {
        this.cardMsgAll = ret.data[0];
      }
    }
  }

  async getTypeList() {
    const ret = await getOptionList([optionKey.queryTypeList]); //请求字典
    this.queryTypeList = ret[optionKey.queryTypeList]; // 客户名称
  }
  public operChange(val: number | string) {
    this.formInline.oprPkId = val;
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }

  public selections: any = [];
  public selectionChange(list: objAny): void {
    this.selections = list;
  }

  public addCard(): void {
    this.$refs?.selectTypeRef.show();
  }
  // public deletes() {
  //   this.$Modal.confirm({
  //     title: i18n.t("tips") + "",
  //     content: i18n.t("isDelete") + "",
  //     onOk: async () => {
  //       const res = await deleteCard({
  //         cardPkIdList: this.selections.map(item => item.cardPkId)
  //       });
  //       if (res.status === this.$config.apiStatus) {
  //         this.$Message.success(i18n.t("deleteSuccess"));
  //         this.getStatistics();
  //         this.getTableList();
  //       }
  //     }
  //   });
  // }
  async changeStatus(status, row?) {
    const cardPkIdList = row
      ? [row.cardPkId]
      : this.selections.map(item => item.cardPkId);
    const res = await updateCardStatus({
      cardPkIdList: cardPkIdList,
      status
    });
    if (res.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getStatistics();
      this.getTableList();
    }
  }

  public editCard(item: objAny) {
    this["$common"].save("non-real-name-card-management-item", item); // 存在本地
    this["$router"].push(
      "/member-management/non-real-name-card-management/non-real-edit-card"
    );
  }
  public cardDetail(item: objAny) {
    this["$common"].save("non-real-name-card-management-item", item); // 存在本地
    this["$router"].push(
      "/member-management/non-real-name-card-management/non-real-name-card-detail"
    );
  }
  // public delCard(item: objAny) {
  //   this["$common"].save("non-real-name-card-management-item", item); // 存在本地
  //   this["$router"].push(
  //     "/member-management/non-real-name-card-management/non-real-del-card"
  //   );
  // }

  mounted() {
    this.getStatistics();
    this.getTableList();
    this.getTypeList();
  }
  beforeRouteEnter(to: objAny, from: objAny, next: Function) {
    if (from.path.indexOf(to.path) != -1) {
      // 从子页面回来
      const name = to.path;
      next((that: objAny) => {
        const formInline = that["$common"].get(name);
        that.formInline = Object.assign(that.formInline, formInline);
      });
    } else {
      next();
    }
  }
  beforeRouteLeave(to: objAny, from: objAny, next: Function) {
    const name = from.path;
    this["$common"].save(name, this.formInline);
    next();
  }
}
